@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.body {
  max-height: 700px;
  display: grid;
  gap: @space-16;
}

.format-label {
  height: 100%;
  padding-top: 10px;
}

.packing-slip-warning {
  --banner-v2-background-color: var(--grey-000);
  --banner-v2-border-color: var(--grey-300);
  --banner-v2-icon-color: var(--blue-600);
  margin-top: 5px;
  border-radius: 4px;
}

.description {
  font-size: 20px;
  padding: 20px 0 10px;
}

.print-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px @space-24;
  align-items: start;
  font-size: 12px;
}

.dropdown-toggler {
  border: 1px solid @settings-page--printing-setup-options-dropdown--border-color;
  border-radius: 5px;
  padding-right: 0;
  background-color: @settings-page--printing-setup-options-dropdown--background-color;
  font-size: 12px;
}

.disabled {
  color: @settings-page--printing-setup-options--disabled--text-color;
}

.loading {
  height: 500px;
}

.promo-banner {
  grid-column: span 2;
}
